module.exports = "../images/wifi.svg?v=7cec588";